// extracted by mini-css-extract-plugin
export default {"Popover":"popover_Popover__2hhOw","popOverContent":"popover_popOverContent__BQs2H"};